// tslint:disable
export var EscoordJobType;
(function (EscoordJobType) {
    // QP Enrollment Feed
    EscoordJobType[EscoordJobType["EnrollmentFeed"] = 1] = "EnrollmentFeed";
})(EscoordJobType || (EscoordJobType = {}));
EscoordJobType['ENROLLMENTFEED'] = 1;
//# sourceMappingURL=EscoordJobType.js.map